import { setPreferredExperience } from '@/console/host/experience-storage';
import { ExperienceId } from '@/console/host/experience.types';

export const switchExperience = (experience: ExperienceId) => {
  setPreferredExperience(experience);
  window.location.assign(window.location.href);
};

// Deliberately leaves the preference alone: `resolveExperience` already answers
// Classic for a path Modern lacks. Storing it here opted people out for good.
export const openPathInOtherExperience = (pathname: string) => {
  window.location.assign(pathname);
};
